module.exports = __webpack_public_path__ + "img/rover.cce32ebf.png";